<div class="disclosure-main">
    <div class="col-lg-12 row">
        <div class="col-lg-12 ml-2 data-sect">
            <div class="col-lg-12">
                <h3>File List</h3>
            </div>
            <hr>
    <!--horizantal scroll table for Disclosure Section-->  
    <ng-template [ngIf]="selectedMainTab !== 'Expense Ratio'">
        <div class="table-sroll-container">
        <div class="table-scroll">
            <table
                class="table table-width-180"
                [svData]="disclosurePDFsData"
                #sv="svDataTable"
                [svRowsOnPage]="pageSize"
                *ngIf="disclosurePDFsData && disclosurePDFsData.length > 0"
            >
                <thead>
                    <tr>
                        <th>Section</th>
                        <th>Sub Section</th>
                        <th>Title</th>
                        <th>Year</th>
                        <th>Month</th>
                        <th>Last Updated On</th>
                        <th class="text-center">View</th>
                        <th class="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of sv.data">
                        <td class="">{{ item?.subType}}</td>
                        <td class="" ><span *ngIf="item.topic !== 'undefined'">{{ item?.topic }}</span></td>
                        <td class="">{{ item?.title }}</td>
                        <td class=""><span *ngIf="item.year !== 'undefined'">{{ item?.year }}</span></td>
                        <td><span *ngIf="item.month !== 'undefined'">{{ item?.month }}</span></td>
                        <td class=""><span *ngIf="item.modifiedDate !== 'undefined'">{{ item?.modifiedDate }}</span></td>
                        <!-- <td class="text-ellipses">{{ item?.title }}</td> -->
                        <td class="text-center">
                            <img
                                src="assets/icons/icon_view.png"
                                class="cursor-pointer"
                                (click)="viewFile(item.url)"
                            >
                        </td>



                        <td class="text-center">
                            <img
                                src="assets/icons/delete_icon.png"
                                class="cursor-pointer"
                                (click)="deleteData(item)"
                            >
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="disclosurePDFsData?.length > pageSize">
                    <tr>
                        <td
                            colspan="5"
                            class="center-paginator"
                        >
                            <sv-bootstrap-paginator></sv-bootstrap-paginator>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
        </div>
    </ng-template> 
    <!--Table for Expentio Ratio-->  
    <ng-template [ngIf]="selectedMainTab === 'Expense Ratio'">
            <table
                class="table"
                [svData]="disclosurePDFsData"
                #sv="svDataTable"
                [svRowsOnPage]="pageSize"
                *ngIf="disclosurePDFsData && disclosurePDFsData.length > 0"
            >
                <thead>
                    <tr>
                        <th>Section</th>
                        <th>Title</th>
                        <th>Year</th>
                        <th>Last Updated On</th>
                        <th class="text-center">View</th>
                        <th class="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of sv.data">
                        <td class="">{{ item?.subType}}</td>
                        <td class="">{{ item?.title }}</td>
                        <td class=""><span *ngIf="item.year !== 'undefined'">{{ item?.year }}</span></td>
                        <td class=""><span *ngIf="item.modifiedDate !== 'undefined'">{{ item?.modifiedDate }}</span></td>
                        <!-- <td class="text-ellipses">{{ item?.title }}</td> -->
                        <td class="text-center">
                            <img
                                src="assets/icons/icon_view.png"
                                class="cursor-pointer"
                                (click)="viewFile(item.url)"
                            >
                        </td>
                        <td class="text-center">
                            <img
                                src="assets/icons/delete_icon.png"
                                class="cursor-pointer"
                                (click)="deleteData(item)"
                            >
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="disclosurePDFsData?.length > pageSize">
                    <tr>
                        <td
                            colspan="5"
                            class="center-paginator"
                        >
                            <sv-bootstrap-paginator></sv-bootstrap-paginator>
                        </td>
                    </tr>
                </tfoot>
            </table>
    </ng-template> 
            <div *ngIf="disclosurePDFsData?.length <= 0">No Data found</div>
        </div>
    </div>
</div>
